import { CBadge } from '@coreui/react';
import * as React from 'react';

export interface ILogLineModel {
    key: string;
    service: string;
    level: string;
    message:string
}

interface IProps {
    line: ILogLineModel;
}

// Composant affichant une ligne de log
//
export class KLogLine extends React.Component<IProps> {
    public constructor(props: any) {
        super(props);
    }

    render() {
        let color = "Light";
        if (this.props.line.level == "Trace") color = "light";
        if (this.props.line.level == "Debug") color = "secondary";
        if (this.props.line.level == "Information") color = "info";
        if (this.props.line.level == "Warning") color = "warning";
        if (this.props.line.level == "Error") color = "danger";
        if (this.props.line.level == "Critical") color = "primary";

        return (
            <tr className="KLogLine">
                <td><div className="key">{this.props.line.key}</div></td>
                <td><div className="service">{this.props.line.service}</div></td>
                <td><div className="level"><CBadge color={color}>{this.props.line.level}</CBadge></div></td>
                <td><div className="message">{this.props.line.message}</div></td>
            </tr>

            )
    }
}